import { TransactionType } from "./type";

// TransactionType intial state
const initialAuthState = {
  transactions: null,
  isLoading: false,
  isCardLoading: false,
  count: null,
  // Apple purchase behind one transaction row, loaded on demand by the IAP dialog.
  iapDetail: null,
  isIapDetailLoading: false
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case TransactionType.GET_TRANSACTION_REQUEST:
      return { ...state, isLoading: true };
    case TransactionType.GET_TRANSACTION_SUCCESS:
      return { ...state, isLoading: false, transactions: action.payload.data };
    case TransactionType.GET_TRANSACTION_FAIL:
      return { ...state, isLoading: false };
    case TransactionType.GET_TRANSACTION_COUNT_REQUEST:
      return { ...state, isCardLoading: true };
    case TransactionType.GET_TRANSACTION_COUNT_SUCCESS:
      return { ...state, isCardLoading: false, count: action.payload.data };
    case TransactionType.GET_TRANSACTION_COUNT_FAIL:
      return { ...state, isCardLoading: false };
    // iapDetail is cleared on request, not just on success: without that a reopened
    // dialog would briefly show the previously opened purchase while the fetch runs.
    case TransactionType.GET_IAP_DETAIL_REQUEST:
      return { ...state, isIapDetailLoading: true, iapDetail: null };
    case TransactionType.GET_IAP_DETAIL_SUCCESS:
      return { ...state, isIapDetailLoading: false, iapDetail: action.payload.data };
    case TransactionType.GET_IAP_DETAIL_FAIL:
      return { ...state, isIapDetailLoading: false };
    default:
      return state;
  }
};
